(ns frontend.ux-overhaul.listing.preview.sub
  (:require
   [frontend.ux-overhaul.listing.generic.model :as model]
   [re-frame.core :as rf]))

(rf/reg-sub
 ::state
 (fn [db [_ listing-id]]
   (get-in db (model/preview-path listing-id))))

(rf/reg-sub
 ::entity-id
 (fn [[_ listing-id] _]
   (rf/subscribe [::state listing-id]))
 (fn [state _]
   (:entity-id state)))
